import React from 'react';
import Inputs from '../../../components/inputs';

interface BankDetails {
  accountHolderName: string;
  accountNumber: string;
  bankName: string;
  ifscCode: string;
}

interface BankDetailsFormProps {
  value: BankDetails;
  onChange: (value: BankDetails) => void;
  errors?: {
    accountHolderName?: string;
    accountNumber?: string;
    bankName?: string;
    ifscCode?: string;
  };
}

const BankDetailsForm: React.FC<BankDetailsFormProps> = ({ value, onChange, errors = {} }) => {
  const handleFieldChange = (field: keyof BankDetails, fieldValue: string) => {
    onChange({
      ...value,
      [field]: fieldValue
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
      <Inputs
        label="Account Holder Name"
        type="text"
        name="accountHolderName"
        className="form-control"
        placeholder="Enter account holder name"
        autoComplete="off"
        isRequired={false}
        options={[]}
        id="accountHolderName"
        value={value.accountHolderName || ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleFieldChange('accountHolderName', e.target.value)
        }
      />

      <Inputs
        label="Account Number"
        type="text"
        name="accountNumber"
        className="form-control"
        placeholder="Enter account number"
        autoComplete="off"
        isRequired={false}
        options={[]}
        id="accountNumber"
        value={value.accountNumber || ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleFieldChange('accountNumber', e.target.value)
        }
      />

      <Inputs
        label="Bank Name"
        type="text"
        name="bankName"
        className="form-control"
        placeholder="Enter bank name"
        autoComplete="off"
        isRequired={false}
        options={[]}
        id="bankName"
        value={value.bankName || ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleFieldChange('bankName', e.target.value)
        }
      />

      <Inputs
        label="IFSC Code"
        type="text"
        name="ifscCode"
        className="form-control"
        placeholder="Enter IFSC code"
        autoComplete="off"
        isRequired={false}
        options={[]}
        id="ifscCode"
        value={value.ifscCode || ''}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleFieldChange('ifscCode', e.target.value)
        }
      />
    </div>
  );
};

export default BankDetailsForm;
